import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { UserInterface } from '../models/user.interface';
import { UserService } from '../core/services/user.service';
import { Location } from '@angular/common';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { BotService } from '../core/services/bot.service';
import { GlobalObservableService } from '../core/services/global-observable.service';
import { Subject, Subscription } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { TieredMenu } from 'primeng/tieredmenu';
import { environment } from 'src/environments/environment';
import { LayoutService } from './service/app.layout.service';
import { PermissionService } from '../core/services/permission.service';
import { SchedulingService } from '../core/services/scheduling.service';

@Component({
  selector: 'globot-topbar',
  providers: [ConfirmationService, MessageService],
  templateUrl: './app.topbar.component.html',
  styleUrls: ['./app.topbar.component.scss'],
})
export class AppTopBarComponent implements OnInit, OnDestroy {
  items!: MenuItem[];

  viewMenuConfig: boolean = false;
  sidebarVisible: boolean = false;
  botId: string = '';
  currentOption: number = 0;
  menuConfig: any[] = [];
  isMobile: boolean = false;
  helpItems!: MenuItem[];
  mobileMenuSections: {
    title: string;
    items: {
      icon?: string;
      materialIcon?: string;
      label: string;
      description: string;
      routerLink?: string;
      externalUrl?: string;
    }[];
  }[] = [];
  mobileMenuFooter: {
    icon?: string;
    materialIcon?: string;
    label: string;
    routerLink?: string;
    externalUrl?: string;
  }[] = [];
  urlProfile: string = '';
  termsUrl = environment.termsUrl;
  privacyUrl = environment.privacyUrl;
  breadcrumbs: { label: string; url: string }[] = [];

  private navCount = 0;

  private readonly routeLabels: Record<string, string> = {
    dashboard: 'Estadísticas',
    leads: 'Leads',
    live: 'Chat en vivo',
    'widget-config': 'Probar asistente',
    config: 'Configuraciones',
    datasource: 'Carga de información',
    embed: 'Agregar a sitio web',
    whatsapp: 'WhatsApp',
    messenger: 'Messenger',
    instagram: 'Instagram',
    clients: 'Clientes',
    clientes: 'Clientes',
    pipeline: 'Pipeline',
    scheduling: 'Agendamiento',
    records: 'Historial',
    'edit-user': 'Mi cuenta',
    'workspace-settings': 'Perfil de negocio',
    team: 'Mi equipo',
    'new-bot': 'Nuevo chatbot',
  };

  private subscription: Subscription = new Subscription();
  private destroy$ = new Subject<void>();
  private schedulingEnabled = false;

  @ViewChild('menubutton') menuButton!: ElementRef;

  @ViewChild('topbarmenubutton') topbarMenuButton!: ElementRef;

  @ViewChild('topbarmenu') menu!: ElementRef;

  @ViewChild('tieredMenu') tieredMenu!: TieredMenu;

  @ViewChild('menu', { read: TieredMenu }) menuTieredMenu!: TieredMenu;

  @ViewChild('helpMenu', { read: TieredMenu }) helpMenu!: TieredMenu;

  @HostListener('window:resize')
  onWindowResize() {
    this.isMobile = this.layoutService.isMobile();
  }

  @HostListener('window:scroll')
  onWindowScroll() {
    if (this.menuTieredMenu) {
      this.menuTieredMenu.hide();
    }
    if (this.helpMenu) {
      this.helpMenu.hide();
    }
  }

  user: UserInterface | undefined = undefined;
  protected readonly undefined = undefined;

  constructor(
    private readonly userService: UserService,
    private readonly router: Router,
    private activatedRoute: ActivatedRoute,
    private messageService: MessageService,
    private botService: BotService,
    private confirmationService: ConfirmationService,
    private globalService: GlobalObservableService,
    private cd: ChangeDetectorRef,
    public layoutService: LayoutService,
    private location: Location,
    private permissionService: PermissionService,
    private schedulingService: SchedulingService
  ) {}

  ngOnInit(): void {
    this.subscription.add(
      this.userService.url$.pipe(takeUntil(this.destroy$)).subscribe((newUrl: string) => {
        this.urlProfile = newUrl;
        this.updateUserPicture(newUrl);
      })
    );
    this.userService.name$.pipe(takeUntil(this.destroy$)).subscribe((newName: string) => {
      if (this.user) {
        this.user.name = newName;
      }
      this.cd.detectChanges();
    });

    this.user = this.userService.getUserLocalStorage();
    this.subscription.add(
      this.userService.user$.pipe(takeUntil(this.destroy$)).subscribe((user) => {
        if (user) {
          this.user = user;
          if (this.items?.length) {
            this.items[0].label =
              'Plan ' + (user.latest_active_subscription?.subscription_type?.alias ?? 'gratuito');
          }
          this.cd.detectChanges();
        }
      })
    );

    this.items = [
      {
        label:
          'Plan ' + (this.user?.latest_active_subscription?.subscription_type?.alias ?? 'gratuito'),
        style: {
          'font-weight': '600',
        },
      },
      {
        separator: true,
      },
      {
        label: 'Mis asistentes',
        icon: 'pi pi-home',
        routerLink: '/dashboard',
        command: () => {
          this.router.navigate(['/dashboard']);
          this.sidebarVisible = false;
          if (this.isMobile) {
            this.sidebarVisible = false;
          } else {
            this.menu?.nativeElement.hide();
          }
        },
      },
      {
        label: 'Mi cuenta',
        icon: 'pi pi-user',
        routerLink: '/dashboard/edit-user',
        command: () => {
          this.router.navigate(['/dashboard/edit-user']);
          if (this.isMobile) {
            this.sidebarVisible = false;
          } else {
            this.menu?.nativeElement.hide();
          }
        },
      },
      {
        label: 'Cerrar sesión',
        icon: 'pi pi-sign-out',
        style: {
          color: '#7B5CF5',
        },
        command: () => this.logout(),
      },
    ];

    this.helpItems = [
      {
        label: 'Términos y condiciones',
        icon: 'pi pi-arrow-up-right',
        command: () => {
          window.open(this.termsUrl, '_blank');
          if (this.isMobile) {
            this.sidebarVisible = false;
          } else {
            this.menu?.nativeElement.hide();
          }
        },
      },
      {
        label: 'Política de privacidad',
        icon: 'pi pi-arrow-up-right',
        command: () => {
          window.open(this.privacyUrl, '_blank');
          if (this.isMobile) {
            this.sidebarVisible = false;
          } else {
            this.menu?.nativeElement.hide();
          }
        },
      },
      {
        label: 'Tutoriales',
        icon: 'pi pi-book',
        command: () => {
          window.open('https://globot.ai/tutoriales/', '_blank', 'noopener');
          if (this.isMobile) {
            this.sidebarVisible = false;
          } else {
            this.menu?.nativeElement.hide();
          }
        },
      },
      {
        label: 'Contactar soporte',
        icon: 'pi pi-comments',
        command: () => {
          this.openSupportForm();
          if (this.isMobile) {
            this.sidebarVisible = false;
          } else {
            this.menu?.nativeElement.hide();
          }
        },
      },
    ];

    this.checkCurrentRoute();
    this.buildMobileMenu();
    this.buildBreadcrumbs();

    this.subscription.add(
      this.router.events
        .pipe(
          filter((event) => event instanceof NavigationEnd),
          takeUntil(this.destroy$)
        )
        .subscribe(() => {
          this.navCount++;
          this.checkCurrentRoute();
          this.buildBreadcrumbs();
        })
    );
    this.subscription.add(
      this.globalService
        .getObservable()
        .pipe(takeUntil(this.destroy$))
        .subscribe((message: { type: string; data?: any }) => {
          if (message.type === 'accountDeleted') {
            this.logout();
          }
          if (message.type === 'logOut') {
            this.user = undefined;
          }
        })
    );
    this.subscription.add(
      this.permissionService.currentRole$
        .pipe(takeUntil(this.destroy$))
        .subscribe(() => this.buildMobileMenu())
    );
    this.subscription.add(
      this.schedulingService.schedulingEnabled$.pipe(takeUntil(this.destroy$)).subscribe((enabled) => {
        this.schedulingEnabled = enabled;
        this.buildMobileMenu();
      })
    );
  }
  private updateUserPicture(newUrl: string): void {
    if (this.user) {
      this.user.picture = newUrl;
    }
    this.cd.detectChanges();
  }

  onSidebarToggle() {
    this.layoutService.toggleSidebar();
  }

  selectOption(i: number) {
    this.currentOption = i;
  }

  checkCurrentRoute(): void {
    const currentRoute = this.router.routerState.snapshot.url;
    this.isMobile = this.layoutService.isMobile();
    const wasBotView = this.viewMenuConfig;
    if (currentRoute?.includes('edit-bot')) {
      this.botId = currentRoute.split('/').slice(-2)[0];
      this.viewMenuConfig = true;
    } else {
      this.viewMenuConfig = false;
    }
    if (wasBotView !== this.viewMenuConfig) {
      this.buildMobileMenu();
    }
  }

  logout() {
    this.user = undefined;
    this.userService.logout();
  }

  navigateTo(url: string | null) {
    if (url) {
      this.sidebarVisible = false;
      //get route current
      const currentRoute = this.router.routerState.snapshot.url;
      //delete last part of route
      const route = currentRoute.split('/').slice(0, -1).join('/');
      //concat route with new route
      url = `${route}/${url}`;
      this.router.navigate([url]);
    }
  }

  navigateToDashboard(event: Event): void {
    event.preventDefault();

    this.router.navigateByUrl('/dashboard').then(() => {
      window.location.reload();
    });
  }
  private buildMobileMenu(): void {
    this.mobileMenuFooter = [
      { materialIcon: 'smart_toy', label: 'Mis asistentes', routerLink: '/dashboard' },
      { icon: 'pi pi-user', label: 'Mi cuenta', routerLink: '/dashboard/edit-user' },
    ];

    if (this.viewMenuConfig) {
      const botBase = `/dashboard/edit-bot/${this.botId}`;
      this.mobileMenuSections = [
        {
          title: 'OPERACIÓN',
          items: [
            {
              icon: 'pi pi-chart-bar',
              label: 'Estadísticas',
              description: 'Métricas y rendimiento',
              routerLink: `${botBase}/dashboard`,
            },
            {
              icon: 'pi pi-comment',
              label: 'Chat en vivo',
              description: 'Chat en tiempo real',
              routerLink: `${botBase}/live`,
            },
            {
              icon: 'pi pi-id-card',
              label: 'Leads',
              description: 'Contactos capturados',
              routerLink: `${botBase}/leads`,
            },
            {
              icon: 'pi pi-history',
              label: 'Historial',
              description: 'Registro de conversaciones',
              routerLink: `${botBase}/records`,
            },
          ],
        },
        {
          title: 'CONFIGURACIÓN',
          items: [
            {
              icon: 'pi pi-play',
              label: 'Probar chatbot',
              description: 'Vista previa del widget',
              routerLink: `${botBase}/widget-config`,
            },
            {
              icon: 'pi pi-cog',
              label: 'Configuraciones',
              description: 'Personalidad y mensajes',
              routerLink: `${botBase}/config`,
            },
            {
              icon: 'pi pi-building',
              label: 'Perfil de negocio',
              description: 'Información de tu empresa',
              routerLink: '/dashboard/workspace-settings',
            },
            {
              icon: 'pi pi-upload',
              label: 'Carga de información',
              description: 'Fuentes de conocimiento',
              routerLink: `${botBase}/datasource`,
            },
          ],
        },
        ...(environment.schedulingEnabled
          ? [
              {
                title: 'AGENDAMIENTO',
                items: [
                  {
                    materialIcon: 'dashboard',
                    label: 'Panel',
                    description: 'Resumen de agendamiento',
                    routerLink: `${botBase}/scheduling`,
                  },
                  ...(this.schedulingEnabled
                    ? [
                        {
                          materialIcon: 'list',
                          label: 'Servicios',
                          description: 'Gestión de servicios',
                          routerLink: `${botBase}/scheduling/services`,
                        },
                        {
                          materialIcon: 'apartment',
                          label: 'Sucursales',
                          description: 'Ubicaciones disponibles',
                          routerLink: `${botBase}/scheduling/branches`,
                        },
                        {
                          materialIcon: 'badge',
                          label: 'Profesionales',
                          description: 'Equipo de atención',
                          routerLink: `${botBase}/scheduling/resources`,
                        },
                        {
                          materialIcon: 'schedule',
                          label: 'Horarios',
                          description: 'Horarios de atención',
                          routerLink: `${botBase}/scheduling/schedules`,
                        },
                        {
                          materialIcon: 'calendar_month',
                          label: 'Citas',
                          description: 'Agenda de reservas',
                          routerLink: `${botBase}/scheduling/appointments`,
                        },
                        {
                          materialIcon: 'settings',
                          label: 'Configuración',
                          description: 'Ajustes de agendamiento',
                          routerLink: `${botBase}/scheduling/config`,
                        },
                      ]
                    : []),
                ],
              },
            ]
          : []),
        {
          title: 'CANALES',
          items: [
            {
              icon: 'pi pi-globe',
              label: 'Agregar a sitio web',
              description: 'Código de inserción',
              routerLink: `${botBase}/embed`,
            },
            {
              icon: 'pi pi-whatsapp',
              label: 'WhatsApp',
              description: 'Conexión y configuración',
              routerLink: `${botBase}/whatsapp`,
            },
            {
              icon: 'pi pi-facebook',
              label: 'Messenger',
              description: 'Conexión y configuración',
              routerLink: `${botBase}/messenger`,
            },
            {
              icon: 'pi pi-instagram',
              label: 'Instagram',
              description: 'Conexión y configuración',
              routerLink: `${botBase}/instagram`,
            },
          ],
        },
      ];
    } else {
      const configItems: {
        icon: string;
        label: string;
        description: string;
        routerLink: string;
      }[] = [
        {
          icon: 'pi pi-users',
          label: 'Mi equipo',
          description: 'Miembros del workspace',
          routerLink: '/dashboard/team',
        },
      ];
      if (this.permissionService.hasPermission('leads.config')) {
        configItems.push({
          icon: 'pi pi-bell',
          label: 'Notificaciones',
          description: 'Alertas y avisos',
          routerLink: '/dashboard/notifications',
        });
      }
      this.mobileMenuSections = [
        {
          title: 'OPERACIÓN',
          items: [
            {
              materialIcon: 'smart_toy',
              label: 'Mis asistentes',
              description: 'Gestiona y configura tus bots',
              routerLink: '/dashboard',
            },
          ],
        },
        {
          title: 'CONFIGURACIÓN',
          items: configItems,
        },
      ];
    }
  }

  private buildBreadcrumbs(): void {
    const url = this.router.url.split('?')[0];
    const segments = url.split('/').filter(Boolean);
    this.breadcrumbs = [];

    // Only build breadcrumbs inside /dashboard
    if (segments[0] !== 'dashboard') return;

    // "Mis chatbots" as root
    this.breadcrumbs.push({ label: 'Mis asistentes', url: '/dashboard' });

    // Inside edit-bot/:id
    const editBotIdx = segments.indexOf('edit-bot');
    if (editBotIdx !== -1 && segments[editBotIdx + 1]) {
      this.addEditBotBreadcrumbs(segments, editBotIdx);
    } else {
      this.addTopLevelBreadcrumb(segments, url);
    }
  }

  private getBotNameFromStorage(): string {
    try {
      const stored = localStorage.getItem('bot');
      if (stored) {
        const bot = JSON.parse(stored);
        if (bot?.name) return bot.name;
      }
    } catch {
      // Ignore parsing errors
    }
    return 'Asistente';
  }

  private addEditBotBreadcrumbs(segments: string[], editBotIdx: number): void {
    const botId = segments[editBotIdx + 1];
    const botName = this.getBotNameFromStorage();

    this.breadcrumbs.push({
      label: botName,
      url: `/dashboard/edit-bot/${botId}/widget-config`,
    });

    // Current sub-page (e.g. dashboard, leads, config...)
    const subPage = segments[editBotIdx + 2];
    if (subPage && this.routeLabels[subPage]) {
      this.breadcrumbs.push({
        label: this.routeLabels[subPage],
        url: `/dashboard/edit-bot/${botId}/${subPage}`,
      });
    }
  }

  private addTopLevelBreadcrumb(segments: string[], url: string): void {
    // CRM section: /dashboard/crm/{clientes|pipeline|dashboard}[/:id]
    const crmIdx = segments.indexOf('crm');
    if (crmIdx !== -1) {
      this.addCrmBreadcrumbs(segments, crmIdx);
      return;
    }

    const lastSegment = segments[segments.length - 1];
    if (lastSegment !== 'dashboard' && this.routeLabels[lastSegment]) {
      this.breadcrumbs.push({
        label: this.routeLabels[lastSegment],
        url: url,
      });
    }
  }

  private addCrmBreadcrumbs(segments: string[], crmIdx: number): void {
    const crmLabels: Record<string, string> = {
      clientes: 'Clientes',
      pipeline: 'Pipeline',
      dashboard: 'CRM',
    };
    const sub = segments[crmIdx + 1];
    const subLabel = crmLabels[sub];
    if (!subLabel) return;

    this.breadcrumbs.push({ label: subLabel, url: `/dashboard/crm/${sub}` });

    // Client detail page: /dashboard/crm/clientes/:id
    if (sub === 'clientes' && segments[crmIdx + 2]) {
      this.breadcrumbs.push({ label: 'Cliente', url: this.router.url.split('?')[0] });
    }
  }

  openSupportForm(): void {
    const name = encodeURIComponent(this.user?.name ?? '');
    const email = encodeURIComponent(this.user?.email ?? '');
    const url = `https://docs.google.com/forms/d/e/1FAIpQLSd8YIlIqRcejXIrdENlfy73H7Tk3NAncicXrByCcnNNCSvQ4A/viewform?usp=pp_url&entry.845095517=${name}&entry.1935575897=${email}`;
    window.open(url, '_blank', 'noopener');
  }

  goBack(): void {
    if (this.navCount > 1) {
      this.location.back();
    } else {
      this.router.navigate(['/dashboard']);
    }
  }

  closeMobileMenu(): void {
    this.sidebarVisible = false;
  }

  onMobileMenuItemClick(item: { routerLink?: string; externalUrl?: string }): void {
    if (item.routerLink) {
      this.router.navigate([item.routerLink]);
    } else if (item.externalUrl) {
      window.open(item.externalUrl, '_blank');
    }
    this.closeMobileMenu();
  }

  trackByBreadcrumbUrl(_index: number, crumb: { label: string; url: string }): string {
    return crumb.url;
  }

  trackBySectionTitle(_index: number, section: { title: string }): string {
    return section.title;
  }

  trackByMenuItem(
    _index: number,
    item: { label: string; routerLink?: string; externalUrl?: string }
  ): string {
    return `${item.label}|${item.routerLink ?? item.externalUrl ?? ''}`;
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.destroy$.next();
    this.destroy$.complete();
  }
}
